/** @format */

// Filters anything carrying a `name` (companies or mapped cards) by a case-insensitive substring.
export const filterProjectsBySearch = <T extends {name: string}>(
  items: ReadonlyArray<T>,
  search: string,
): ReadonlyArray<T> => {
  const query = search.trim().toLowerCase();
  if (!query) {
    return items;
  }
  return items.filter(item => item.name.toLowerCase().includes(query));
};
